import api from './api';

export default {
  getImports() {
    return new Promise((resolve, reject) => {
      api
        .get('/imports')
        .then(response => resolve(response.data.data))
        .catch(error => reject(error.data));
    });
  },
  getFile(importId) {
    return new Promise((resolve, reject) => {
      api
        .get(`/imports/${importId}`)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error.data));
    });
  }
};
